/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_SubtitleInputs */

const cs_social_templates_subtitle = /** @type {(inputs: Social_Templates_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrajte Typst šablony pro generování obrázků příspěvků.`)
};

const en_social_templates_subtitle = /** @type {(inputs: Social_Templates_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Typst templates for social post image generation.`)
};

/**
* | output |
* | --- |
* | "Upload Typst templates for social post image generation." |
*
* @param {Social_Templates_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_subtitle = /** @type {((inputs?: Social_Templates_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_subtitle(inputs)
	return cs_social_templates_subtitle(inputs)
});